'use client';
import React, { useLayoutEffect, useEffect } from 'react';
import { gsap } from 'gsap';

function Header() {
  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo('.header', { y: 200 }, { y: 0 }, '+=2.5');
    tl.fromTo(
      '.header .container',
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      '-=0'
    );

    return () => tl.kill();
  }, []);

  // Add this if you want to keep using data-background attribute
  useEffect(() => {
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach(element => {
      const bgImage = element.getAttribute('data-background');
      element.style.backgroundImage = `url(${bgImage})`;
    });
  }, []);

  return (
    <div className="header startup-header" data-scroll-index="0">
      <div
        className="valign bg-img"
        style={{
          backgroundImage: `url('/dark/assets/imgs/background/1.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
        data-overlay-dark="5"
      >
        <div className="container pt-40">
           <div className="caption">
             <div className="lg-text fw-600">
               <div className="text d-flex align-items-center">
                 <span>Give your</span>
               </div>
               <div className="text">Home</div>
               <div className="text">some shine</div>
             </div>
             <p>
             We combine quality services in cleaning, sanitization, pest control and civil work to enhance your living and working spaces.
             </p>
           </div>
         </div>
      </div>
    </div>
  );
}

export default Header;